<template>
  <div v-if="checkAccessUser()">
    <div class="row">
      <div class="col-lg-12 col-md-12">
        <div class="card card-power-university">
          <div class="card-header">
            <h4 class="card-title">Power University</h4>
            <p class="category">by Microsoft</p>
            <img src="static/img/logo_power_university.png" class="logo-power-university" alt="Power University by Microsoft">
          </div>
          <div class="card-content">
            <div class="row">
              <div class="col-md-12" style="padding-bottom: 5px;">
                <a href="https://forms.office.com/r/AnFYqTyj3Q" target="_blank" class="btn btn-primary btn-fill btn-wd">
                  <i class="fa fa-check-circle" aria-hidden="true"></i> Termo de compromisso
                </a>
              </div>            
            </div>
            <hr>
            <div class="row" style="padding-bottom: 5px;">
              <div class="col-md-12">
                <p class="text-center">Iniciar jornada na Plataforma Microsoft</p>
              </div>   
              <div class="col-md-6">
                <a href="static/pdf/Power_University_Trilhas.pdf" target="_blank" class="btn btn-info btn-fill btn-wd">
                  <i class="fa fa-list-ul" aria-hidden="true"></i> Trilhas
                </a>
              </div>
              <div class="col-md-6">
                <a href="static/pdf/Power_University_Certificacao_ESI.pdf" target="_blank" class="btn btn-info btn-fill btn-wd">
                  <i class="fa fa-certificate" aria-hidden="true"></i> Certificação ESI
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { checkAccessPowerUniversity } from 'src/helpers/general'

  export default {
    computed: {
      currentUser () {
        return this.$store.getters.currentUser
      }
    },
    methods: {
      checkAccessUser () {
        return checkAccessPowerUniversity(this.currentUser)
      }
    }
  }
</script>
<style>
.card-power-university .card-title {
    font-size: 1em;
    text-transform: uppercase;
    font-weight: 700 !important;
    line-height: 1.2em;
}

.card-power-university .card-content p {
  font-weight: 600;
}

.card-power-university .card-content a {
  width: 100%;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/UserProfile/PowerUniversity.vue